var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GeminiAppNameEnum } from '@workalizer/shared/enums';
var ALL_GEMINI_APPS = Object.values(GeminiAppNameEnum);
export var getInvocationsChartPeriodKeys = function (userId) {
    return userId
        ? ['previousPeriod', 'currentPeriod', 'team']
        : ['previousPeriod', 'currentPeriod'];
};
var hasAppActivityInAnyPeriod = function (periods, appName) {
    return periods.some(function (period) {
        var _a, _b, _c, _d;
        return ((_a = period.currentPeriod[appName]) !== null && _a !== void 0 ? _a : 0) > 0 ||
            ((_b = period.previousPeriod[appName]) !== null && _b !== void 0 ? _b : 0) > 0 ||
            ((_d = (_c = period.team) === null || _c === void 0 ? void 0 : _c[appName]) !== null && _d !== void 0 ? _d : 0) > 0;
    });
};
var sumCurrentPeriodCounts = function (periods, appName) {
    return periods.reduce(function (sum, period) { var _a; return sum + ((_a = period.currentPeriod[appName]) !== null && _a !== void 0 ? _a : 0); }, 0);
};
export var buildChartAppNames = function (periods) {
    return ALL_GEMINI_APPS.filter(function (appName) {
        return hasAppActivityInAnyPeriod(periods, appName);
    }).sort(function (a, b) {
        return sumCurrentPeriodCounts(periods, b) - sumCurrentPeriodCounts(periods, a);
    });
};
export var sortAppNamesByCount = function (appNames, getCount) {
    return __spreadArray([], appNames, true).filter(function (appName) { return getCount(appName) > 0; })
        .sort(function (a, b) { return getCount(b) - getCount(a); });
};
